export const initialLogInData = {
    email: "",
    password: ""
}
export const initialSignUpData = {
    firstName: "",
    lastName: "",
    email: "",
    password: ""
}
export const guestData = {
    email: "adarshbalika@gmail.com",
    password: "adarshBalika123",
  };
